import PropTypes from 'prop-types';

import {Box, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Link} from '@amblique/king-living/app/contentful/models/link';

/**
 * PromoBannerItem component
 * Individual promotional message within the PromoBanner.
 *
 * @param {Object} props - Component props
 * @param {Contentful.PromoBannerItem} props.component - PromoBannerItem component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const PromoBannerItem = ({component, isComplete = true, isFetching = false, ...props}) => {
  const {promotionText, link} = component;

  const styles = useMultiStyleConfig('contentful/promo-banner-item', {
    component,
    isComplete,
    isFetching,
  });

  return (
    <Box {...styles.root} {...props}>
      <Text {...styles.text}>{promotionText}</Text>
      {link && (
        <Box as="span" sx={styles.link}>
          <Link
            component={link}
            isComplete={isComplete}
            isFetching={isFetching}
          />
        </Box>
      )}
    </Box>
  );
};

PromoBannerItem.displayName = 'PromoBannerItem';
PromoBannerItem.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
};
